import React, { useEffect } from "react";
import { useTranslation,Trans  } from 'react-i18next';
const Banner = () => {
   const { t ,i18n } = useTranslation();
    const isMarathi = i18n.language === 'mr';
  useEffect(() => {
    // Select the container element
    const container = document.querySelector(".container");
    const target = document.querySelector(".serach-bar");
 
    if (container && target) {
      // Get the computed margin-right of the container
      const containerStyle = getComputedStyle(container);
      const marginRight = containerStyle.marginRight;

      // Set the custom CSS variable on the target element
      target.style.setProperty("--custom-left", marginRight);
      // console.log(`Margin-Right: ${marginRight}`);
    }
  }, []);

  return (
    <>
      <section className="bs-banner custom-margin-top">
        <div className="banner-img">
          {/* Replaced Next.js Image with a standard img tag */}
          <img
            className="img-fluid"
            src={
            isMarathi
              ? "/images/home/banner/banner-mr.jpeg"
              :"/images/home/banner/banner.jpg"
            }
            alt="banner"
            width="1920"
            height="500"
          />
        </div>

        {/* <div className="banner-text">
          <h2 className="hero-text" data-aos="fade-in" data-aos-delay="200">
            Redefining Redevelopment With 3&nbsp;T&apos;s - Transparency, Trust
             & Timely Completion
          </h2>
        </div> */}

        {/* <div className="serach-bar" data-aos="fade-in" data-aos-delay="300">
          <input type="text" placeholder="Search By" />
        </div> */}
      </section>
    </>
  );
};

export default Banner;
